import { Panel } from "primereact/panel";
import { Formatter } from "../../../../../../services/formatter/formatter.service";
import { useTranslation } from "react-i18next";
import { classNames } from "primereact/utils";
import UiButton from "../../../../../../components/button/Button";
import { RiPushpinLine, RiPushpinFill } from "react-icons/ri";

const NotesHistoryPanel = ({
	date,
	type,
	callerName,
	editing,
	pinned,
	pinLoading,
	onTogglePin,
	children,
}: {
	date: string; // Date
	/** Translation key (e.g. PARTICIPANT.DASHBOARD.NOTES.COACHING_CALL) or literal label for wellness types */
	type: string;
	callerName: string;
	editing: boolean;
	pinned: boolean;
	pinLoading?: boolean;
	onTogglePin: () => void;
	children: React.ReactNode;
}) => {
	const { t } = useTranslation("common");
	const typeLabel = type.includes(".") ? t(type) : type;

	return (
		<Panel
			className={classNames(
				"participant-notes-history__panel",
				pinned && "participant-notes-history__panel--pinned"
			)}
			header={
				<div className="participant-notes-history__panel-header">
					<div className="participant-notes-history__panel-header-info">
						{/* Date */}
						<span>
							{Formatter.dateISOToString(date, {
								day: "2-digit",
								month: "2-digit",
								year: "2-digit",
								hour: "2-digit",
								minute: "2-digit",
							})}
						</span>

						<div className="participant-notes-history__panel-header-info-center">
							{/* Note type */}
							<span>{typeLabel}</span>

							{/* Created by */}
							<span>{callerName}</span>
						</div>
					</div>

					<UiButton
						className={classNames(
							"p-button-text participant-notes-history__pin-btn",
							pinned && "participant-notes-history__pin-btn--active"
						)}
						icon={pinned ? <RiPushpinFill /> : <RiPushpinLine />}
						onClick={(e) => {
							e.stopPropagation();
							onTogglePin();
						}}
						disabled={pinLoading}
						tooltip={
							pinned
								? "PARTICIPANT.DASHBOARD.NOTES.UNPIN_NOTE"
								: "PARTICIPANT.DASHBOARD.NOTES.PIN_NOTE"
						}
						tooltipOptions={{ position: "top" }}
					/>
				</div>
			}
		>
			<div
				className={classNames(
					"participant-notes-history__panel-content",
					editing && "participant-notes-history__panel-content--editing"
				)}
			>
				{children}
			</div>
		</Panel>
	);
};

export default NotesHistoryPanel;
